var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 644,
    height: 635,
    viewBox: "0 0 644 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 365.3V487C24.5 503.4 33.2 518.5 47.4 526.6L152.8 587.4L281.1 513.3V365.2L152.8 291.1L24.5 365.3Z",
    fill: "#F6A51E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.7 365.3V487C619.7 503.4 611 518.5 596.8 526.6L491.4 587.4L363.1 513.3V365.2L491.4 291.1L619.7 365.3Z",
    fill: "#F6A51E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.5 587.4L591.7 529.6L610.6 508.1L363.2 365.3V513.4L491.5 587.4Z",
    fill: "#FED007"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M491.5 302.8L609.8 371.1V487C609.8 499.7 602.9 511.6 591.9 518L491.5 576L373.2 507.7V371L491.5 302.8ZM491.5 291.2L363.2 365.3V513.4L491.5 587.5L596.9 526.7C611.1 518.5 619.8 503.4 619.8 487.1V365.4L491.5 291.2Z",
    fill: "#F6A51E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8 587.4L58 532.8L50.4 528.3L33.5 508.2L281 365.3V513.4L152.8 587.4Z",
    fill: "#FED007"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.8 302.8L271 371V507.6L152.7 575.9L52.3 517.9C41.3 511.5 34.4 499.7 34.4 486.9V371L152.8 302.8ZM152.8 291.2L24.5 365.3V487C24.5 503.4 33.2 518.5 47.4 526.6L152.8 587.4L281.1 513.3V365.2L152.8 291.2Z",
    fill: "#F6A51E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.399902 291.7V158C0.399902 141.6 9.09993 126.5 23.2999 118.4L139.1 51.6L277.8 131.7V291.8L139.1 371.9L0.399902 291.7Z",
    fill: "#F6A51E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M643.8 291.7V158C643.8 141.6 635.1 126.5 620.9 118.4L505.1 51.6L366.4 131.7V291.8L505.1 371.9L643.8 291.7Z",
    fill: "#9E441B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M505.2 51.5L613.5 114.1L634 137.3L366.5 291.7V131.6L505.2 51.5Z",
    fill: "#F6A51E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M505.2 63.1L616 127.1C627 133.5 633.9 145.3 633.9 158.1V286L505.2 360.3L376.5 286V137.4L505.2 63.1ZM505.2 51.5L366.5 131.6V291.7L505.2 371.8L643.9 291.7V158C643.9 141.6 635.2 126.5 621 118.4L505.2 51.5Z",
    fill: "#F6A51E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M139 51.5L36.6001 110.7L28.4001 115.4L10.1001 137.2L277.7 291.7V131.6L139 51.5Z",
    fill: "#FEF6FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139 63.1L267.7 137.4V286L139 360.3L10.3 286V158C10.3 145.3 17.2 133.4 28.2 127L139 63.1ZM139 51.5L23.2 118.3C8.99995 126.5 0.300049 141.6 0.300049 157.9V291.6L139 371.7L277.7 291.6V131.5L139 51.5Z",
    fill: "#F6A51E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 475.8V158.9L322.1 0.400024L596.6 158.9V475.8L322.1 634.3L47.6001 475.8Z",
    fill: "#F6A51E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 628.9L590.8 472.5L547.7 447.6L342.2 566.3C329.8 573.4 322.2 586.6 322.2 600.9L322.1 628.9Z",
    fill: "#9E441B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 475.8L322.1 634.3V600.8C322.1 586.5 314.5 573.3 302.1 566.2L116.5 459.1C104.1 452 88.9001 452 76.6001 459.1L47.6001 475.8Z",
    fill: "#FED007"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 33.9V3.90002L51.8 161.3L76.6 175.6C89 182.7 104.2 182.7 116.5 175.6L302.1 68.5C314.5 61.3 322.1 48.2 322.1 33.9Z",
    fill: "#FEF6FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M593.5 474L592.5 161.3L567.7 175.6C555.3 182.7 547.7 195.9 547.7 210.2V447.5L593.5 474Z",
    fill: "#9E441B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 11.9L586.6 164.6V470L322.1 622.7L57.6001 470V164.6L322.1 11.9ZM322.1 0.400024L47.6001 158.9V475.9L322.1 634.4L596.6 475.9V158.9L322.1 0.400024Z",
    fill: "#F6A51E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8999 135.7L150.2 168.2C160.4 161.8 165.1 155.7 178.9 146.8L124.9 115.3L93.8999 135.7Z",
    fill: "#F6A51E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M498.9 197.5L371.3 123.8C356.4 115.2 339.4 110.6 322.2 110.6C305 110.6 288 115.2 273.1 123.8L145.5 197.5C135.5 203.3 129.3 214 129.3 225.5V297C129.3 322.6 139.8 347.1 158.1 364.8V370C158.1 406.5 177.7 440.5 209.2 458.7L322.2 524L435.2 458.7C467.6 440 485.7 406.7 486.3 364.8C504.7 347 515.1 322.6 515.1 297V225.5C515.1 214 508.9 203.3 498.9 197.5Z",
    fill: "#1C1128"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 323.3L167.1 236.1V297C167.1 317.1 177.8 335.7 195.2 345.7L195.9 346.1V370C195.9 393.1 208.1 414.3 228 425.8L322 480.1L416 425.8C435.9 414.3 448.1 393.1 448.1 362.8V346.1L448.8 345.7C466.2 335.6 476.9 317.1 476.9 297V236.1L322.1 323.3Z",
    fill: "#F6A51E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 323.3V480.1L416.1 425.8C436 414.3 448.2 393.1 448.2 362.8V346.1L448.9 345.7C466.3 335.6 477 317.1 477 297V236.1L322.1 323.3Z",
    fill: "#9E441B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.2 253.3L317.3 332.1L322.2 334.9L327.1 332.1L467.2 253.3V297.1C467.2 313.6 458.3 328.9 444.1 337.2L443.4 337.6L438.4 340.5V346.3V363C438.4 388.3 429 407.1 411.3 417.3L322.3 468.7L233.3 417.3C216.6 407.7 206.2 389.6 206.2 370.2V346.3V340.5L201.2 337.6L200.5 337.2C186.2 329 177.4 313.6 177.4 297.1V253.3H177.2ZM477.1 236.2L322.1 323.4L167.1 236.2V297.1C167.1 317.2 177.8 335.8 195.2 345.8L195.9 346.2V370.1C195.9 393.2 208.1 414.4 228 425.9L322 480.2L416 425.9C435.9 414.4 448.1 393.2 448.1 362.9V346.2L448.8 345.8C466.2 335.7 476.9 317.2 476.9 297.1V236.2H477.1Z",
    fill: "#F6A51E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M206 340.4L322.1 405.7V417.2L206 351.9V340.4Z",
    fill: "#9E441B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M438.2 340.4L322.1 405.7V417.2L438.2 351.9V340.4Z",
    fill: "#F6A51E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6 215.3L322.1 291.2L453.6 215.3L352.2 156.8C333.5 146 310.6 146 291.9 156.8L190.6 215.3Z",
    fill: "#698445"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M352.3 156.7C343 151.3 332.6 148.6 322.2 148.6V291.2L453.7 215.3L352.3 156.7Z",
    fill: "#1F4927"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 236.2L195.9 218.3L322.1 291.2L448.3 218.3L322.1 236.2Z",
    fill: "#143321"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M322.1 158.7C330.9 158.7 339.6 161 347.2 165.4L433.6 215.3L322.1 279.7L210.6 215.3L297 165.4C304.6 161 313.3 158.7 322.1 158.7ZM322.1 148.7C311.7 148.7 301.3 151.4 292 156.8L190.6 215.3L322.1 291.2L453.6 215.3L352.2 156.8C342.9 151.4 332.5 148.7 322.1 148.7Z",
    fill: "#2B5E36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold2);
export default __webpack_public_path__ + "static/media/gold-2.010eefcf4ef6535f0573e4c57e1d2bc5.svg";
export { ForwardRef as ReactComponent };